<template>
	<v-col class="reward">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">List Reward</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-medal</v-icon>
			<div class="pl-2">Reward</div>
			<div class="px-2">/</div>
			<div>List Reward</div>
		</div>

		<div class="mt-5">
			<v-row v-if="Object.keys(pointMember).length > 0">
				<v-col cols="12" sm="6" md="4" lg="4">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<div class="d-flex flex-wrap justify-space-between">
							<div class="pl-2 cl-dark-green font-size-10 font-weight-bold my-auto">Total Point Anda</div>
							<div class="pr-2 cl-primary font-size-12 font-weight-bold my-auto">
								<v-icon small class="cl-primary" style="margin-top: -2px;">mdi-circle-medium</v-icon>
								<span class="pl-1">{{ pointMember.total_point | toNumber }}</span>
							</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row v-if="false">
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab elevation="2" @click="showReward = 'rewardTitik'"><template v-if="showReward === 'rewardTitik'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Titik</v-tab>
							<v-tab @click="showReward = 'rewardPribadi'"><template v-if="showReward === 'rewardPribadi'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Pribadi</v-tab>
							<v-tab @click="showReward = 'rewardGrup'"><template v-if="showReward === 'rewardGrup'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Grup</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<template v-if="showReward === 'rewardTitik'">
			<ListRewardTitik></ListRewardTitik>
		</template>

	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ListRewardTitik from './components/ListRewardTitik';

export default {
	components: {
		ListRewardTitik,
	},
	data() {
		return {
			showReward: 'rewardTitik',
		}
	},
	computed: {
		...mapState('reward', ['pointMember']),
	},
	methods: {
		...mapActions('reward', ['getPointMember']),
	},
	created(){
		this.$store.dispatch('setPageTitle', `List Reward`)
		this.getPointMember()
	}
};
</script>